<template>
  <div class="addplace-page container">
    <h1 class="title">
      Editar Lugar
      <span v-if="$route.query.lang">(Idioma: {{$route.query.lang}})</span>
      <button
        disabled="disabled"
        class="button is-loading is-disabled is-white"
        style="background-color: #f5f5f5"
        v-if="isLoading"
      >
        ...
      </button>
    </h1>
    <div class="page-content">
      <tabs type="toggle" :on-tab-click="TabSwitch" :active-index="activeTab">
        <tab-item label="Dados do Lugar">
          <place-form
            :is-disabled="isFormDisabled"
            :is-loading="isFormDisabled"
            button-label="Atualizar Lugar"
            :form-data="formData"
            :disabled-fields="disabledFields"
            :on-submit="updatePlace"
          />
        </tab-item>
        <tab-item label="Imagens do Lugar">
          <image-upload
            accepttypes="image/*"
            :max="1000"
            @hasnoimages="withNoImages"
            @hasimages="withImages"
            fileSizeLimit="10MB"
            :on-submit="uploadImages"
            :on-set-cover="setCover"
            :on-set-legend="setLegend"
            :on-remove-item="removeImage"
            :images="PlaceImages"
            :enable-caption="false"
          />
        </tab-item>
      </tabs>
      <p class="has-text-centered">
        <router-link :to="`/${$route.params.lang}/places/${$route.params.id}`" class="button is-link">Visualizar Lugar</router-link>
        <router-link :to="`/${$route.params.lang}/places`" class="button is-link">Voltar para listagem de Lugares</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AsideMenuCtrlMixin from './AsideMenuCtrlMixin'
import ImageUploadMixin from '../forms/ImageUploadMixin'
import PlaceForm from '../forms/PlaceForm'
import ImageUpload from '../ImageUpload'
import { UpdatePlace } from '../../api/place'
import { prepareFormData } from '../../helpers'

export default {
  name: 'EditPlacePage',
  mixins: [AsideMenuCtrlMixin, ImageUploadMixin],
  components: { PlaceForm, ImageUpload },
  data () {
    return {
      isLoading: false,
      isFormDisabled: false,
      formData: {},
      placeId: '',
      activeTab: 0,
      disabledFields: {
        name: true,
        shortDescription: true,
        longDescription: true,
        informations: true,
        operation: true,
        language: true
      }
    }
  },
  created () {
    const { tab } = this.$route.query
    if (tab) {
      this.activeTab = parseInt(tab)
    }
    if (!this.Place.id || !tab) {
      this.getPlace()
    } else {
      this.prepareFormData(this.Place)
    }
    this.disabledFields.categoryId = this.me.role === 'moderator'
  },
  computed: {
    ...mapGetters(['Place', 'PlaceImages', 'DefaultLanguage', 'me'])
  },
  methods: {
    ...mapActions(['RetrievePlace', 'RetrievePlaceImages']),
    getPlace () {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        this.RetrievePlace(this.$route.params.id)
          .then(
            success => {
              this.isLoading = false
              this.prepareFormData(this.Place)
              resolve()
            },
            error => {
              console.log(error.response)
              this.isLoading = false
              this.$notify.open({
                type: 'danger',
                content: 'Não foi possível obter os dados do Lugar.',
                duration: 10000
              })
              reject(error)
            }
          )
      })
    },
    updatePlace (place) {
      // console.log(prepareFormData(place))
      let p = {
        ...place,
        name: null,
        shortDescription: null,
        longDescription: null,
        informations: null,
        operation: null,
        language: null,
        ratings: null,
        ratesList: null,
        qrcodesColleted: null,
        isFavoritePlace: null,
        moderators: null,
        images: null
      }
      this.isFormDisabled = true
      UpdatePlace(prepareFormData(p), this.placeId)
        .then(
          success => {
            this.isFormDisabled = false
            this.$notify.open({
              type: 'success',
              content: 'O Lugar foi atualizado com sucesso!',
              duration: 10000
            })
            this.$router.push(`/${this.$route.params.lang}/places`)
          },
          error => {
            console.log(error.response)
            this.isFormDisabled = false
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível atualizar o Lugar no momento.',
              duration: 10000
            })
          }
        )
    },
    prepareFormData (data) {
      this.placeId = this.Place.id
      this.formData = {
        ...data,
        categoryId: data.category.id,
        id: null,
        updatedAt: null,
        coverImage: null,
        category: null,
        relatedPlaces: null,
        createdAt: null
      }
    },
    TabSwitch (tab) {
      if (tab === 1) {
        this.isLoading = true
        const { language, id } = this.Place
        const getImg = (id) =>
          this.RetrievePlaceImages({ params: { limit: 50, skip: null, language, id } })
            .then(
              success => {
                this.isLoading = false
              },
              error => {
                console.log(error.response)
                this.isLoading = false
                this.$notify.open({
                  type: 'danger',
                  content: 'Não foi possível obter as imagens do Lugar.',
                  duration: 10000
                })
              }
            )
        if (id) {
          getImg(id)
        } else {
          this.getPlace()
            .then(
              success => {
                getImg(this.Place.id)
              }
            )
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/EditPlacePage.vue